var map = {
	"./ca.json": [
		36557,
		557
	],
	"./de.json": [
		9510,
		510
	],
	"./es.json": [
		55029
	],
	"./fr.json": [
		29533,
		533
	],
	"./it.json": [
		79816,
		816
	],
	"./ja.json": [
		55708,
		708
	],
	"./ko.json": [
		91503,
		503
	],
	"./pt.json": [
		46461,
		461
	],
	"./ru.json": [
		36344,
		344
	],
	"./zh-cn.json": [
		51499,
		499
	],
	"./zh-tw.json": [
		37939,
		939
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42960;
module.exports = webpackAsyncContext;